module.exports = __webpack_public_path__ + "img/Musi.59dd0cca.png";